import type { SVGProps } from 'react';
const DawnFlagVC = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-VC_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-VC_svg__a)">
      <path fill="#08C47A" d="M10.477 0h11.524v16H10.477z" />
      <path fill="#0C87E1" fillRule="evenodd" d="M0 16h7.333V0H0z" clipRule="evenodd" />
      <path
        fill="#FECB2F"
        fillRule="evenodd"
        d="M6.286 16h9.429V0H6.286z"
        clipRule="evenodd"
      />
      <path
        fill="#08C47A"
        fillRule="evenodd"
        d="m7.333 6.4 1.571-3.2 1.572 3.2-1.572 3.2zm4.19 0 1.572-3.2 1.571 3.2-1.571 3.2zM11 7.467l-1.572 3.2 1.572 3.2 1.571-3.2z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default DawnFlagVC;
